<template>
  <div class="checked-modal">
    <el-dialog title="选择素材" :visible.sync="dialogVisible" width="1600px" :append-to-body="true" top="10px" :close-on-click-modal="false">
      <template slot="title">
        <el-tabs v-model="materialType" style="margin-bottom: -28px">
          <el-tab-pane label="素材管理" name="material"></el-tab-pane>
          <el-tab-pane label="YouTube" name="youtube" v-if="selectType === 'video'"></el-tab-pane>
        </el-tabs>
      </template>
      <div class="modal-body">
        <div class="body-wrap">
          <div class="modal-slide" v-if="materialType === 'material'">
            <el-input class="search-folder" placeholder="搜索文件夹" suffix-icon="el-icon-search" v-model="folderName"></el-input>
            <el-tree
              :data="folderOptions"
              @node-click="handleNodeClick"
              :filter-node-method="filterNode"
              :default-expanded-keys="treeData"
              node-key="id"
              :props="{
                children: 'children',
                label: 'name',
              }"
              ref="treeRef"
            >
              <span class="custom-tree-node" slot-scope="{ node }">
                <svg-icon icon-class="folder1" class="forder-icon" v-if="node.label === 'root'" />
                <span class="forder-text">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
          <div class="modal-content" :style="{ width: materialType === 'youtube' ? '100%' : '' }">
            <!-- 素材管理 -->
            <div v-if="materialType === 'material'">
              <el-form :inline="true" :model="formData">
                <el-form-item label="标签:" class="form-item">
                  <el-cascader
                    @change="inputSearch"
                    style="width: 188px"
                    placeholder="请选择"
                    v-model="formData.tag"
                    :options="tagList"
                    clearable
                    :props="{ multiple: false, value: 'id', label: 'tagName', emitPath: false }"
                    filterable
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="设计:" class="form-item">
                  <el-select clearable v-model="formData.designer" placeholder="选择设计" filterable style="width: 188px" @change="inputSearch">
                    <el-option v-for="item in designerList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="后期:" class="form-item">
                  <el-select clearable v-model="formData.demander" placeholder="选择后期" filterable style="width: 188px" @change="inputSearch">
                    <el-option v-for="item in demanderList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="类型:" class="form-item">
                  <el-select style="width: 188px" clearable v-model="formData.direction" placeholder="选择类型" @change="inputSearch">
                    <el-option v-for="item in directionList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="尺寸:" class="form-item">
                  <el-select v-model="formData.resolution" placeholder="选择尺寸" style="width: 188px" @change="inputSearch" filterable clearable>
                    <el-option v-for="item in resolutionList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div class="top-line">
                <el-checkbox v-model="checkAll" @change="handleCheckAll">全选</el-checkbox>
                <!-- <div class="selectText">
                已选<span class="num-text">{{ Object.keys(selectedList).length }}
                </span>个
              </div> -->
                <div class="group-wrap" v-if="showGroupNum">
                  每个素材组最多包含
                  <el-input-number
                    size="mini"
                    v-model="groupMaterialNum"
                    :min="1"
                    :precision="0"
                    style="width: 80px; margin: 0 4px"
                    controls-position="right"
                  ></el-input-number>
                  个{{ selectType === "video" ? "视频" : "图片" }}
                </div>
                <div style="margin-left: auto">
                  <el-dropdown>
                    <span class="el-dropdown-link"> 按时间排序<i class="el-icon-arrow-down el-icon--right"></i> </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item> 按时间排序</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-input
                    v-model="formData.key"
                    suffix-icon="el-icon-search"
                    placeholder="请输入内容"
                    style="width: 160px; margin-left: 8px"
                    @input="inputSearch"
                  ></el-input>
                </div>
              </div>
              <div class="material-wrap">
                <ul class="material-list">
                  <li
                    :class="['material-item', Object.keys(selectedList).includes(item.uuid) ? 'cur' : '']"
                    v-for="item of materialList"
                    :key="item.id"
                    @click="handleSelect(item)"
                    :title="item.name"
                  >
                    <div class="img-wrap">
                      <img :src="/^video/g.test(item.format) ? item.coverPath : item.path" />
                    </div>
                    <div class="content-wrap">
                      <div class="material-msg">
                        <span class="ma-name">{{ item.name }}</span>
                        <span class="na-user"><i class="el-icon-user-solid user-icon"></i>{{ item.designerName }}</span>
                      </div>
                      <div class="material-size">
                        <span class="size-text">{{ item.size }}M</span>
                        <span class="size-text">{{ item.modifyDate }}</span>
                      </div>
                      <div class="tag-list">
                        <span class="tag-item" v-for="tagItem of item.tags" :key="tagItem.id">{{ tagItem.name }}</span>
                      </div>
                    </div>
                  </li>
                </ul>

                <self-pagination :total="pageData.total" :pageSize="pageData.size" :currentPage="pageData.page" @getCurrentPage="changePage" @handleSizeChange="changePageSize"></self-pagination>
              </div>
            </div>
            <!-- YouTube -->
            <div v-else>
              <el-form :inline="true" :model="youtubeFormData">
                <el-form-item label="频道:" class="form-item">
                  <el-select clearable v-model="youtubeFormData.channel" placeholder="选择频道" filterable style="width: 188px" @change="changeChannelId">
                    <el-option v-for="item in channelList" :key="item.channelId" :label="item.channelName" :value="item.channelId"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="播放列表:" class="form-item">
                  <el-select clearable v-model="youtubeFormData.playlistId" placeholder="选择播放列表" filterable style="width: 188px" @change="changePlayId">
                    <el-option v-for="item in playList" :key="item.id" :label="item.playName" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div class="top-line">
                <el-checkbox v-model="checkYoutubeAll" @change="handleCheckAll">全选</el-checkbox>
                <div style="margin-left: auto">
                  <el-dropdown>
                    <span class="el-dropdown-link"> 按时间排序<i class="el-icon-arrow-down el-icon--right"></i> </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item> 按时间排序</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-input
                    v-model="youtubeFormData.key"
                    suffix-icon="el-icon-search"
                    placeholder="请输入内容"
                    style="width: 160px; margin-left: 8px"
                    @change="getYoutubeList"
                  ></el-input>
                </div>
              </div>
              <div class="material-wrap">
                <ul class="material-list">
                  <li
                    :class="['material-item', Object.keys(selectedList).includes(item.uuid) ? 'cur' : '']"
                    v-for="item of youtubeList"
                    :key="item.id"
                    @click="handleSelect(item)"
                    :title="item.name"
                    style="width: 287px"
                  >
                    <div class="img-wrap">
                      <img :src="item.thumbnailUrl" />
                    </div>
                    <div class="content-wrap">
                      <div class="material-msg">
                        <span class="ma-name">{{ item.name }}</span>
                        <span class="na-user"><i class="el-icon-user-solid user-icon"></i>{{ item.creatorName }}</span>
                      </div>
                      <div class="material-size">
                        <span class="size-text">{{ item.modifyTime }}</span>
                      </div>
                    </div>
                  </li>
                </ul>

                <self-pagination
                  :total="youtubePageData.total"
                  :pageSize="youtubePageData.size"
                  :currentPage="pageData.page"
                  @getCurrentPage="changeYoutubePage"
                  @handleSizeChange="changeYoutubePageSize"
                ></self-pagination>
              </div>
            </div>

            <div class="view-wrap" v-show="Object.keys(selectedList).length > 0">
              <div class="view-test">已选择：{{ Object.keys(selectedList).length }}/{{ maxFileNum }}</div>
              <ul class="view-list">
                <li class="view-item" v-for="item of Object.values(selectedList)" :key="item.id">
                  <img :src="/^video/g.test(item.format) ? item.coverPath : item.path || item.thumbnailUrl" />
                  <span class="close-btn" @click="handleSelect(item)"><i class="el-icon-close"></i></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <span slot="footer" class="footer-wrap">
          <div class="bottom-wrap">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmSelect">确 定</el-button>
          </div>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getFolders, getFiles } from "@/api/promotion.js";
import { getTagRuleList, getTagPropertySelectList } from "@/api/property";
import SvgIcon from "@/components/SvgIcon.vue";
import { getChannelOptions, getYouTubePlayList, getYoutubeFiles } from "@/api/property.js";
export default {
  name: "MaterialModal",
  props: {
    singleSelect: {
      type: Boolean,
      default: false,
    },
    // video 视频， image 图片
    selectType: {
      type: String,
      default: undefined,
    },
    //是否显示分组信息
    showGroupNum: {
      type: Boolean,
      default: false,
    },
    //是否是穿山甲开屏
    isUnionSplash: {
      type: Boolean,
      default: false,
    },
    // 图片的宽
    width: {
      type: String,
      default: "",
    },
    // 图片的高
    height: {
      type: String,
      default: "",
    },
  },
  components: {
    SvgIcon,
  },
  data() {
    return {
      dialogVisible: false,
      materialType: "material",
      formData: {
        folderId: 1,
        tag: null,
        designer: null,
        key: "",
        direction: null,
        resolution: null,
      },
      youtubeFormData: {
        channel: "",
        playlistId: "",
        key: "",
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      youtubePageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      checkAll: false,
      checkYoutubeAll: false,
      folderOptions: [],
      treeData: [],
      tagList: [],
      designerList: [],
      demanderList: [],
      directionList: [],
      materialList: [],
      youtubeList: [],
      channelList: [],
      playList: [],
      selectedList: {}, //改为对象
      timer: null,
      loading: false,
      groupMaterialNum: "1",
      folderName: "",
      resolutionList: [],
    };
  },
  methods: {
    showModal() {
      this.dialogVisible = true;
      this.selectedList = {};
      this.initSelect();
      this.materialType = "material";
    },
    initSelect() {
      getFolders().then((res) => {
        this.folderOptions = res.data;
        this.treeData = [res.data[0].id, res.data[1].id];
      });
      getTagRuleList().then((res) => {
        this.tagList = res.data;
      });
      getTagPropertySelectList({ type: 1 }).then((res) => {
        this.directionList = res.data;
      });
      getTagPropertySelectList({ type: 4 }).then((res) => {
        this.designerList = res.data;
      });
      getTagPropertySelectList({ type: 5 }).then((res) => {
        this.demanderList = res.data;
      });
      getTagPropertySelectList({ type: 2 }).then((res) => {
        this.resolutionList = res.data;
      });
      if (this.selectType === "video") {
        getChannelOptions().then((res) => {
          this.channelList = res.data;
          this.changeChannelId();
        });
      }
      this.getMaterialList();
    },
    changeChannelId() {
      this.youtubePageData.page = 1;
      this.youtubeFormData.playlistId = "";
      getYouTubePlayList({
        channelId: this.youtubeFormData.channel,
      }).then((res) => {
        this.playList = res.data;
      });
      this.getYoutubeList();
    },
    changePlayId() {
      this.youtubePageData.page = 1;
      this.getYoutubeList();
    },
    changePage(page) {
      this.pageData.page = page;
      this.getMaterialList();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getMaterialList();
    },
    changeYoutubePage(page) {
      this.youtubePageData.page = page;
      this.getYoutubeList();
    },
    changeYoutubePageSize (size) {
      this.youtubePageData.page = 1;
      this.youtubePageData.size = size;
      this.getYoutubeList();
    },
    getMaterialList() {
      let parmas = {
        pageSize: this.pageData.size,
        pageIndex: this.pageData.page,
        folderId: this.formData.folderId ? this.formData.folderId : "",
        tag: this.formData.tag ? this.formData.tag : "",
        designer: this.formData.designer ? this.formData.designer : "",
        direction: this.formData.direction ? this.formData.direction : "",
        resolution: this.formData.resolution ? this.formData.resolution : "",
        key: this.formData.key ? this.formData.key : "",
        type: this.selectType ? this.selectType : "",
        platType: 5,
        width: this.width ? this.width : "",
        height: this.height ? this.height : "",
      };
      if (this.isUnionSplash) {
        parmas.imageType = "SPLASH";
      }
      getFiles(parmas).then((res) => {
        if (res.code === "0000") {
          this.pageData.total = res.count;
          this.materialList = res.list;
          const selectedUuidList = Object.keys(this.selectedList);
          let flag = true;
          if (this.materialList.length > 0) {
            this.materialList.map((item) => {
              if (!selectedUuidList.includes(item.uuid)) {
                flag = false;
              }
            });
          } else {
            flag = false;
          }
          this.checkAll = flag;
        }
      });
    },
    getYoutubeList() {
      getYoutubeFiles({
        channel: this.youtubeFormData.channel,
        playlistId: this.youtubeFormData.playlistId,
        privacyStatusList: ["public", "unlisted"],
        name: this.youtubeFormData.key,
        size: this.youtubePageData.size,
        page: this.youtubePageData.page,
      }).then((res) => {
        this.youtubeList = res.data.list;
        this.youtubePageData.total = res.data.total;
      });
    },
    inputSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.pageData.page = 1;
        this.getMaterialList();
      }, 500);
    },
    handleSelect(item) {
      let id = item.uuid;
      if (this.selectedList[id]) {
        this.$delete(this.selectedList, id);
        this.checkAll = false;
        this.checkYoutubeAll = false;
      } else {
        if (Object.keys(this.selectedList).length < this.maxFileNum) {
          this.$set(this.selectedList, id, item);
          let flag = true;
          const selectedUuidList = Object.keys(this.selectedList);
          this.materialList.map((item) => {
            if (!selectedUuidList.includes(item.uuid)) {
              flag = false;
            }
          });
          this.checkAll = flag;
        } else {
          this.$message({
            message: "所选素材数量达到上限",
            type: "warning",
          });
        }
      }
    },
    handleCheckAll() {
      const selectedUuidList = Object.keys(this.selectedList);
      if (this.materialType === "material") {
        if (this.checkAll) {
          this.materialList.map((item) => {
            if (!selectedUuidList.includes(item.uuid)) {
              if (Object.keys(this.selectedList).length < this.maxFileNum) {
                this.$set(this.selectedList, item.uuid, item);
              } else {
                this.$message({
                  message: "所选素材数量达到上限",
                  type: "warning",
                });
              }
            }
          });
        } else {
          this.materialList.map((item) => {
            if (selectedUuidList.includes(item.uuid)) {
              this.$delete(this.selectedList, item.uuid);
              this.checkAll = false;
            }
          });
        }
      } else {
        if (this.checkYoutubeAll) {
          this.youtubeList.map((item) => {
            if (!selectedUuidList.includes(item.uuid)) {
              if (Object.keys(this.selectedList).length < this.maxFileNum) {
                this.$set(this.selectedList, item.uuid, item);
              } else {
                this.$message({
                  message: "所选素材数量达到上限",
                  type: "warning",
                });
              }
            }
          });
        } else {
          this.youtubeList.map((item) => {
            if (selectedUuidList.includes(item.uuid)) {
              this.$delete(this.selectedList, item.uuid);
              this.checkAll = false;
            }
          });
        }
      }
    },
    confirmSelect() {
      let arrayList = Object.keys(this.selectedList);
      if (this.singleSelect && arrayList.length !== 1) {
        this.$message({
          message: "请选择一个素材",
          type: "warning",
        });
        return;
      }
      if (arrayList.length === 0) {
        this.$message({
          message: "请至少选择一个素材",
          type: "warning",
        });
        return;
      }
      let parmas = {
        mapList: this.selectedList,
        groupNum: this.showGroupNum ? this.groupMaterialNum : null,
      };
      this.$emit("selectOk", parmas);
      this.dialogVisible = false;
    },
    handleNodeClick(node) {
      this.formData.folderId = node.id;
      this.pageData.page = 1;
      this.getMaterialList();
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
  computed: {
    maxFileNum() {
      return this.showGroupNum ? parseInt(this.groupMaterialNum) * 30 : 20;
    },
  },
  watch: {
    folderName(val) {
      this.$refs.treeRef.filter(val);
    },
  },
};
</script>

<style lang="less" scoped>
.el-dialog__wrapper {
  overflow: hidden;
  height: calc(100% - 10px);
}
.modal-body {
  height: calc(100vh - 96px);
  .body-wrap {
    display: flex;
    height: calc(100% - 72px);
    .modal-slide {
      width: 200px;
      flex-shrink: 0;
      border-right: 1px dashed rgba(216, 216, 216, 1);
      margin-right: 23px;
      height: calc(100vh - 108px);
      .search-folder {
        width: 150px;
        margin-bottom: 8px;
      }
      .custom-tree-node {
        .forder-icon {
          margin-right: 5px;
        }
        .forder-text {
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
        }
      }
      /deep/ .el-tree {
        height: calc(100% - 36px);
        overflow: auto;
        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: rgba(0, 0, 0, 0.2);
        }
      }
      /deep/.el-tree .el-icon-caret-right:before {
        background: url("../../../../assets/right.png") no-repeat 0 0px;
        content: "";
        display: block;
        width: 20px;
        height: 20px;
        background-size: 25px;
        background-position: center;
      }
      //没有子节点
      /deep/.el-tree .el-tree-node__expand-icon.is-leaf::before {
        background: transparent;
        content: "";
        display: block;
        width: 20px;
        height: 20px;
        background-size: 25px;
        background-size: 16px;
      }
      /deep/ .el-tree-node.is-current > .el-tree-node__content {
        background: rgba(24, 144, 255, 0.1);
        color: rgba(24, 144, 255, 1);
      }
    }
    .modal-content {
      width: calc(100% - 220px);
      display: flex;
      flex-direction: column;
      /deep/ .form-item {
        margin-right: 30px;
        margin-bottom: 8px;
      }
      .top-line {
        display: flex;
        align-items: center;
        /deep/ .el-checkbox__label {
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
        }
        .selectText {
          white-space: nowrap;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          .num-text {
            color: rgba(24, 144, 255, 1);
            font-size: 14px;
            margin: 0 5px;
          }
        }
        .group-wrap {
          display: flex;
          align-items: center;
          margin: 0 auto 0 16px;
        }
      }
      .material-wrap {
        border-radius: 2px;
        background: rgba(244, 244, 244, 1);
        margin-top: 8px;
        padding: 16px 0px 0px 16px;
        /deep/ .pagination-wrap .el-pagination {
          margin: 0 1px 1px 0;
        }
        .material-list {
          height: 530px;
          margin: 0px;
          padding: 0px;
          list-style: none;
          display: flex;
          flex-wrap: wrap;
          overflow: auto;
          align-content: flex-start;
          &::-webkit-scrollbar {
            display: none;
            width: 0 !important;
            height: 0 !important;
            background: transparent;
          }
          .material-item {
            width: 243px;
            height: 237px;
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, 0.11);
            box-sizing: border-box;
            background: rgba(255, 255, 255, 1);
            cursor: pointer;
            flex-shrink: 0;
            margin: 0 16px 16px 0;
            user-select: none;
            &.cur {
              border: 1px solid rgba(24, 144, 255, 1);
            }
            .img-wrap {
              height: 140px;
              padding: 9px 9px 0 9px;
              box-sizing: border-box;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .content-wrap {
              .material-msg {
                color: rgba(0, 0, 0, 0.85);
                font-size: 14px;
                display: flex;
                padding: 10px;
                .ma-name {
                  width: 100%;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .na-user {
                  white-space: nowrap;
                  .user-icon {
                    color: rgb(102, 102, 102);
                    font-size: 16px;
                    margin-right: 5px;
                  }
                }
              }
              .material-size {
                padding: 0 9px;
                color: rgba(0, 0, 0, 0.45);
                font-size: 13px;
                .size-text {
                  margin-right: 16px;
                }
              }
              .tag-list {
                display: flex;
                padding: 7px 0px 0px 9px;
                .tag-item {
                  color: rgba(0, 0, 0, 0.85);
                  font-size: 12px;
                  line-height: 22px;
                  border-radius: 2px;
                  background: rgba(233, 233, 233, 0.6);
                  padding: 0 6px;
                  margin-right: 5px;
                }
              }
            }
          }
        }
      }
      .view-wrap {
        display: flex;
        align-items: center;
        margin-top: -20px;
        .view-test {
          flex-shrink: 0;
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
          margin-right: 24px;
        }
        .view-list {
          width: 100%;
          padding: 0px;
          margin: 0px;
          list-style: none;
          display: flex;
          overflow-x: auto;
          overflow-y: hidden;
          padding-top: 26px;
          .view-item {
            width: 101px;
            height: 67px;
            margin-right: 12px;
            position: relative;
            flex-shrink: 0;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .close-btn {
              position: absolute;
              right: -5px;
              top: -5px;
              display: inline-block;
              width: 14px;
              height: 14px;
              border-radius: 50%;
              background: rgba(214, 214, 214, 1);
              text-align: center;
              line-height: 14px;
              cursor: pointer;
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  .footer-wrap {
    .bottom-wrap {
      text-align: right;
      padding: 24px 0;
    }
  }
}
</style>
